import { ConnectedApp } from '@cms-max/medicare-api-sdk'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal, getModalType, setModal } from 'redux/reducers/modal'
import { ConnectedAppsCard } from '../components'
import ConnectedAppsStopModal, { connectedAppsStopModalId } from '../components/ConnectedAppsStopModal/ConnectedAppsStopModal'
import { useDeleteConnectedApp } from 'queries/connectedApps'
import { useState } from 'react'

export interface ConnectedAppsPageContentProps {
    apps: ConnectedApp[]
  }

export const ConnectedAppsPageContent: React.FC<ConnectedAppsPageContentProps> = ({ apps }) => {
  const { t } = useTranslation('connectedApps')
  const modal = useSelector(getModalType)
  const dispatch = useDispatch()
  const { mutate, isError, isLoading, isSuccess, reset } = useDeleteConnectedApp()
  const [selectedApp, setSelectedApp] = useState<ConnectedApp>()

  return (
    <>
      {selectedApp && modal === connectedAppsStopModalId && (
        <ConnectedAppsStopModal
          connectedAppName={selectedApp.name}
          onClose={() => dispatch(closeModal())}
          onConfirm={() => { mutate({ id: `${selectedApp.id}` }) }}
          isError={isError}
          isLoading={isLoading}
          isSuccess={isSuccess}
        />
      )}
      <div className='ds-u-padding--0 ds-u-margin-top--0'>
          <div className='ds-u-padding--1'>
              {t('showingApps', { appLength: apps?.length })}
          </div>
          {apps?.map((app) => {
            return (
              <ConnectedAppsCard
                key={app.id}
                name={app.name}
                contacts={app.contacts}
                policyUri={app.policyUri}
                termsOfServiceUri={app.termsOfServiceUri}
                logoUri={app.logoUri}
                handleStopSharingClick={() => {
                  // Reset the mutate so the 'isLoading, isError, isSuccess' variabels are reset
                  reset()
                  setSelectedApp(app)
                  dispatch(setModal({ modalType: connectedAppsStopModalId }))
                }}
                id={app.id}
              />
            )
          })}
      </div>
    </>
  )
}
